import axios from 'axios'
import {
  get,
  post,
  del,
  getfile
} from '@/http/request'
import {
  HOST
} from '@/http/config'

// 列表
export function getCanteenlist(params) {
  return get(`${HOST}basis-canteen/list`, params)
}
// 根据id删除
export function delCanteen(params) {
  return del(`${HOST}basis-canteen/delete`, params)
}
// 详情
export function getCanteenDetails(params) {
  return get(`${HOST}basis-canteen/get`, params)
}
// 新增
export function saveCanteen(params) {
  return post(`${HOST}basis-canteen/save`, params)
}
// 修改
export function updateCanteen(params) {
  return post(`${HOST}basis-canteen/update`, params)
}
//历史修改版本列表
export function getHistoryList(params) {
  return get(`${HOST}basis-canteen-history/list`, params)
}
// 历史修改版本详情
export function getHistoryDetial(params) {
  return get(`${HOST}basis-canteen-history/get`, params)
}
// 导出
export function Export(params) {
  return getfile(`${HOST}basis-canteen/export`, params)
}



// WEBPACK FOOTER //
// ./src/views/baseInfoManagement/cantennManagement/api.js